const endPoint =
  process.env.REACT_APP_BACKEND_HOST || 'https://api.bktraffic.com';

const api = {
  getPublicData: '/api/get-public-data',
  findNearSegment: '/api/segment/find-near',
  getTrafficStatus: '/api/traffic-status/get-status',
  getTrafficStatusV2: '/api/traffic-status/get-status-v2',
  adminLogin: '/api/auth/admin-utraffic/login',
  adminVerifyToken: '/api/auth/admin-utraffic/me',
  adminConfig: '/api/admin-utraffic/traffic-status-config',
  adminUpdateTrafficStatus: '/api/admin-utraffic/traffic-status',
  adminSpeechReport: '/api/admin-utraffic/speech-report',
  collectSpeechRecord: '/api/report/speech-report/collect',
  getSpeechRecordScripts: '/api/report/speech-report/scripts',
  callNoiseEnhanceApi: '/api/report/speech-report/enhance',
  getAllRegisterHealthFacilities: '/api/register-health-facility/all-register',
  getLicenseImage: '/api/register-health-facility/register-image',
  updateRegisterState: '/api/register-health-facility/update-state',
  createHealthFacility: '/api/health-facilities/create'
};

export { endPoint, api };
